import * as React from 'react';
import { Responsive } from 'semantic-ui-react';
import { DesktopGridView, MobileGridView } from './rows';
import OperationCount from './operation-count';

import './styles.css';

export class OperationGridView extends React.Component {
  public render() {
    return (
      <>
        <OperationCount />
        <Responsive maxWidth={Responsive.onlyTablet.maxWidth} as={React.Fragment}>
          <MobileGridView />
        </Responsive>
        <Responsive {...Responsive.onlyComputer} as={React.Fragment}>
          <DesktopGridView />
        </Responsive>
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/component.tsx